export default "__VITE_ASSET__C_08P8yY__";